import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Brain, Plus } from 'lucide-react'
import api from '../../services/api'

export default function PsychosocialList() {
  const [hazards, setHazards] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get('/psychosocial')
      .then(r => { setHazards(r.data.data); setTotal(r.data.total) })
      .finally(() => setLoading(false))
  }, [])

  const RISK_BADGE: Record<string, string> = { critical: 'badge-critical', high: 'badge-high', medium: 'badge-medium', low: 'badge-low' }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>Psychosocial Hazards</h1>
          <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>{total} total · WHS Reg 2025 (NSW) s55A</p>
        </div>
        <Link to="/psychosocial/new" className="btn btn-primary"><Plus size={16} /> Report Hazard</Link>
      </div>

      {loading ? <div className="text-center py-12" style={{ color: 'var(--text-muted)' }}>Loading...</div> :
        hazards.length === 0 ? (
          <div className="card text-center py-16">
            <Brain size={40} className="mx-auto mb-3" style={{ color: 'var(--text-muted)' }} />
            <p style={{ color: 'var(--text-muted)' }}>No psychosocial hazards recorded</p>
          </div>
        ) : (
          <div className="space-y-2">
            {hazards.map(h => (
              <div key={h.id} className="card flex items-center gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-mono text-xs" style={{ color: 'var(--text-muted)' }}>{h.hazard_number}</span>
                    <span className="badge badge-medium">{h.hazard_type?.replace('_', ' ')}</span>
                    {h.confidential ? <span className="badge" style={{ background: 'var(--purple-light)', color: 'var(--purple)' }}>Confidential</span> : null}
                  </div>
                  <p className="text-sm" style={{ color: 'var(--text)' }}>{h.description}</p>
                  <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>{h.site_name || 'No site'} · {new Date(h.created_at).toLocaleDateString('en-AU')}</p>
                </div>
                {h.risk_rating && <span className={`badge ${RISK_BADGE[h.risk_rating] || ''}`}>{h.risk_rating}</span>}
                <span className={`badge ${h.status === 'open' ? 'badge-high' : 'badge-low'} capitalize`}>{h.status}</span>
              </div>
            ))}
          </div>
        )}
    </div>
  )
}
